import { createContext } from 'react'

import { HeaderContextType } from '../Header.types'

const HeaderContext = createContext<HeaderContextType>({
  isOpen: false,
  setIsOpen: () => {},
  compressed: false,
  menu: [],
  isMobile: undefined,
})

export default HeaderContext
